export default "__VITE_ASSET__CZRf9ckz__"